var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canEdit)?_c('div',{staticClass:"view"},[_c('EditCreateTitleBox',{attrs:{"label":_vm.title}}),_c('div',{staticClass:"sm-products-add-edit-container"},[_c('ProductAddOrEditContent',{attrs:{"product-data":_vm.data},on:{"onProductSaved":_vm.onProductSaved,"onGotoListProduct":_vm.gotoList}})],1)],1):_c('div',[_c('forbidden')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }